module.exports = __webpack_public_path__ + "src/assets/textures/env/corn_cards/corn_stalk_card_05_1k_bake.png";